import { commentsData } from '@/mocks/homepage';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            读者热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            百万漫迷的真实声音，看看大家都在追什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 flex gap-4"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="font-medium text-sm text-foreground-900 whitespace-nowrap">
                    {comment.name}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {comment.date}
                  </span>
                  <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {comment.manga}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}